import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { ToastNotification } from '@carbon/react';
import { NotificationContext } from '@/lib/notification-context';

interface Notice { id: number; title: string }
export function NotificationProvider({ children }: { children: ReactNode }) {
  const [notices, setNotices] = useState<Notice[]>([]);
  const notify = useCallback((title: string) => {
    const id = Date.now();
    setNotices((current) => [...current, { id, title }]);
  }, []);
  const value = useMemo(() => notify, [notify]);
  return (
    <NotificationContext.Provider value={value}>
      {children}
      <div className="carbon-toast-region" aria-live="polite">
        {notices.map((notice) => (
          <ToastNotification key={notice.id} kind="error" title={notice.title} timeout={6000}
            onClose={() => setNotices((current) => current.filter((n) => n.id !== notice.id))} />
        ))}
      </div>
    </NotificationContext.Provider>
  );
}
